import AbstractRange from "@/core/types/AbstractRange";

/**
 * Диапазон целых чисел
 */
class IntRange extends AbstractRange<number> {
  constructor(start: number | null = null, end: number | null = null) {
    super(start, end);
  }

    static fromServer(intRange, result = new IntRange()) {
        return super.fromServer(intRange, result);
    }

  /**
   * Валидация диапазона целых чисел
   * @protected
   */
  protected _validate(): void {
    super._validate();

    if (this._start !== null && !Number.isInteger(this._start)) {
      throw new Error('Start must be an integer');
    }
    if (this._end !== null && !Number.isInteger(this._end)) {
      throw new Error('End must be an integer');
    }
  }

    /**
     * Форматирование изменения диапазона для журнала изменений (@Title_ru_RU diff callback)
     *
     * Примеры:
     *   { start: 2, end: 8 } → { start: 5, end: 25 }  =>  ' с "от 2 °C до 8 °C" на "от 5 °C до 25 °C"'
     *   { start: 2, end: 8 } → null                     =>  ' с "от 2 °C до 8 °C" на "без ограничений"'
     *   null                 → { start: 2, end: 8 }     =>  ' с "без ограничений" на "от 2 °C до 8 °C"'
     */
    static diffIntRange(oldValue: IntRange, newValue: IntRange): string {
        const format = (v: IntRange) =>
            v?.isFilled()
                ? `от ${v.start} °C до ${v.end} °C`
                : 'без ограничений';

        return ` с "${format(oldValue)}" на "${format(newValue)}"`;
    }
}

export default IntRange;